import { makeStyles } from "@material-ui/core";

export const mentorTipStyles = makeStyles((theme) => ({
  container: {
    padding: "27px",
  },
  iconContainer: {
    marginRight: "20px",
  },
  mentorTipDetails: {
    display: "flex",
    alignItems: "center",
  },
  details: {
    flexGrow: 1,
  },
  default: {
    background: "#E9FBF8",
    color: "#00A3A3",
    "& .header": {
      display: "flex",
      alignItems: "center",
      "& svg": {
        marginRight: "14px",
      },
      "& .MuiTypography-root": {
        color: "#00A3A3",
        fontWeight: 700,
        fontFamily: "Lato",
        fontSize: theme.typography.pxToRem(16),
      },
    },
    "& .MuiTypography-root": {
      fontFamily: "Lato",
      fontWeight: 400,
      fontSize: theme.typography.pxToRem(16),
    },
  },
  success: {
    background: "#E7F9EE",
    color: "#284524",
    "& .header": {
      display: "flex",
      alignItems: "center",
      "& svg": {
        marginRight: "14px",
      },
      "& .MuiTypography-root": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "#0ABF52",
        fontWeight: 600,
        fontFamily: "Lato",
        fontSize: theme.typography.pxToRem(20),
      },
    },
    "& .MuiTypography-root": {
      color: "#284524",
      fontFamily: "Lato",
      fontWeight: 400,
      fontSize: theme.typography.pxToRem(16),
      "& b": {
        fontWeight: 700,
      },
    },
  },
  error: {
    background: "#FFF4F4",
    color: "#CF1B1B",
    "& .header": {
      display: "flex",
      alignItems: "center",
      "& .errorContainer": {
        display: "flex",
        alignItems: "center",
        flexWrap: "nowrap",
        "& .errorTitle": {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      },
      "& svg": {
        marginRight: "14px",
      },
    },
    "& .MuiTypography-root": {
      fontFamily: "Inter",
      fontWeight: 600,
      fontSize: theme.typography.pxToRem(20),
      "& b": {
        fontWeight: 800,
      },
    },
  },
  body: {
    "& li p": {
      marginBottom: "20px",
    },
    "& .details": {
      width: "100%",
    },
  },
}));
